import { createContext } from 'react';

const DropdownCloseContext = createContext(() => {});

export default DropdownCloseContext;
